<template v-if="subMenuList.length > 0">
  <div>
    <mds-list-group-item
      :active="subMenu.isActive"
      @click.native.stop.prevent="setActiveStatus(subMenu)"
      v-for="subMenu in subMenuList"
      :text="subMenu.name"
    ></mds-list-group-item>
  </div>
</template>

<script>
import { MdsListGroupItem } from "@mds/list-group";
export default {
  inheritAttrs: false,

  props: {
    sectionId: { type: Number },
    menuId: { type: Number },
    subMenus: {
      type: Array,
    },
  },
  components: {
    MdsListGroupItem,
  },

  data() {
    return {
      selectedMenuId: 0,
    };
  },
  computed: {
    subMenuList() {
      return this.subMenus.filter(
        (sr) => sr.menuId == this.menuId && sr.sectionId == this.sectionId
      );
    },
  },

  async created() {},
  methods: {
    setActiveStatus(subMenu) {
      this.$emit("onClick", this.sectionId, this.menuId, subMenu.id);
    },
  },
};
</script>
